<template>
  <div class="price-guidance-tabs">
    <div class="price-guidance">
      <span class="title fl">价格指导</span>
      <div v-loading="loading">
        <el-tabs
          v-model="activeName1"
          class="el-tabs__customize price-guidance-tabs"
          @tab-click="handleClickOne"
          :lazy="false"
        >
          <el-tab-pane
            v-for="(item, index) in list1"
            :key="index"
            :name="`tab${index}`"
            :label="item.name"
          >
            <span
              class="left-btn"
              @click="moreLeftData(item1)"
              v-if="priceList.length > 0 && pageNo != 1"
            >
              <i class="el-icon-caret-left"></i>
            </span>
            <div class="list" v-if="priceList.length > 0">
              <div
                class="focusNew ccui-clearfix"
                v-for="(item1, index1) in priceList"
                :key="index1"
              >
                <div
                  @mouseenter="showDialog(item1, index, index1, $event)"
                  @mouseleave="hideDialog(item1, index, index1)"
                >
                  <div class="top">
                    {{ item1.title }}
                  </div>
                  <div class="content">
                    <div class="openPrice">
                      开盘价
                      <span
                        class="price"
                        :style="
                          item1.raise >= 1
                            ? 'color: #FF4747;'
                            : item1.raise === 0
                            ? 'color: #0089ef;'
                            : 'color: #2BA571;'
                        "
                      >
                        {{ item1.startPrice }}
                        <i
                          v-if="item1.raise >= 1"
                          style="color: #FF4747;"
                          class="el-icon-top"
                        ></i>
                        <i
                          v-else-if="item1.raise === 0"
                          style="color: #0089ef;"
                        ></i>
                        <i
                          v-else-if="item1.raise < 1"
                          style="color: #2BA571;"
                          class="el-icon-bottom"
                        ></i>
                      </span>
                    </div>
                    <div class="closePrice">
                      较昨日
                      <span
                        class="price"
                        :style="
                          item1.raise >= 1
                            ? 'color: #FF4747;'
                            : item1.raise === 0
                            ? 'color:  #0089ef;'
                            : 'color: #2BA571;'
                        "
                      >
                        <i
                          v-if="item1.raise >= 1"
                          style="color: #FF4747;"
                          class="el-icon-plus"
                        ></i>
                        <i
                          v-else-if="item1.raise === 0"
                          style="color:  #0089ef;"
                        ></i>
                        <i
                          v-else-if="item1.raise < 1"
                          style="color: #2BA571;"
                        ></i>

                        {{ item1.raise === 0 ? "持平" : item1.raise }}
                      </span>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="address">
                      {{ item1.cpName }}

                      <span style="margin-left: 10px;">{{
                        item1.areaName
                      }}</span>
                    </div>
                    <span class="time">{{
                      item1.publishTime.slice(0, -3)
                    }}</span>
                  </div>
                  <!-- v-if="hoverIndex === index1" -->
                  <div v-if="hoverIndex === index1" class="dialog">
                    <div class="triangle-down"></div>
                    <div class="ZXtitle">
                      {{ item1.title }}
                    </div>
                    <div class="cpName">
                      {{ item1.cpName }}
                    </div>
                    <div
                      :id="'echartsContainer' + `${index}${index1}`"
                      style="width: 381px; height: 285px;"
                    ></div>
                    <div class="areaName">
                      {{ item1.areaName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="dataNull" v-else>
              <span>暂无数据</span>
            </div>
            <span
              class="right-btn"
              @click="moreRightData(item1)"
              v-if="priceList.length > 0 && pageNo != total"
            >
              <i class="el-icon-caret-right"></i>
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="location-select">
        <i class="el-icon-location-outline" style="color: #eb4025"></i>
        <el-select
          v-model="addressValue"
          placeholder=""
          @change="addressChange"
          filterable
        >
          <el-option
            v-for="item in addressOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </div>
      <el-link
        :underline="false"
        type="info"
        class="notice-more"
        @click="handleViewAll(source.marketDynamic)"
      >
        更多 ></el-link
      >
    </div>

    <div class="towBox"></div>
  </div>
</template>

<script>
import {
  selectPortalTypeList,
  selectPortalCityList,
  selectPortalInfoList,
  qryMySteelTrendInfo
} from "@/app/shop/api/shopping";
import * as echarts from "echarts";
import { announcementPageSource } from "@/setting/setting";
export default {
  name: "priceGuidance",
  data() {
    return {
      hoverIndex: null,
      showChart: false,
      list1: [],
      list2: [],
      list3: [],
      loading: false,
      priceList: [],
      addressOptions: [],
      data: [10, 20, 30, 40, 50],
      addressValue: "",
      childrenList2: [],
      activeName1: "tab0",
      activeName2: "tab0",
      source: announcementPageSource,
      marketDynamicUrl: "",
      priceInfoUrl: "",
      pageNo: 1,
      total: 0,
      interfaceType: "4" // 获取市场动态下的：分析报告、市场详情、行业要闻  默认是：分析报告
    };
  },
  mounted() {},
  activated() {
    selectPortalTypeList({}).then(res => {
        if (res.data.code === "0") {
          this.list1 = res.data.data;
          this.init("9001", this.pageNo, "");
        }
      })
    
  },
  deactivated() {
    this.list1 = [];
    this.list2 = [];
    this.list3 = [];
    this.priceList = [];
    this.childrenList2 = [];
    this.activeName1 = "tab0";
    this.activeName2 = "tab0";
    this.marketDynamicUrl = "";
    this.priceInfoUrl = "";
  },
  beforeDestroy() {},
  methods: {
    init(code, pageNo, type) {
      this.loading = true;
          selectPortalCityList({ type: code }).then(resOne => {
            if (resOne.data.code === "0") {
              this.addressOptions = resOne.data.data;
              this.addressOptions.forEach(item => {
                if (item.name == "上海") {
                  this.addressValue = type ? this.addressValue : item.code;
                }
              });

              selectPortalInfoList({
                areaCode: this.addressValue,
                type: code,
                name: this.addressValue,
                pageNo: pageNo,
                pageSize: 8
              }).then(resTwo => {
                if (resTwo.data.code === "0") {
                  this.priceList = resTwo.data.data.rows;
                  this.pageNo = resTwo.data.data.pageNo;
                  this.total = resTwo.data.data.total;
                  this.loading = false;
                }
              });
            }
          });
        
    },
    handleViewAll() {
      this.$router.push({
        path: "/announcementsList",
        query: {
          source: "1"
          // interfaceType: "1"
        }
      });
    },
    moreLeftData(item) {
      console.log(this.activeName1, "moreData");
      let codeValue = "";
      if (this.activeName1 == "tab0") {
        codeValue = "9001";
      }
      if (this.activeName1 == "tab1") {
        codeValue = "9002";
      }
      if (this.activeName1 == "tab2") {
        codeValue = "9003";
      }
      if (this.activeName1 == "tab3") {
        codeValue = "9004";
      }
      if (this.activeName1 == "tab4") {
        codeValue = "9005";
      }
      if (this.activeName1 == "tab5") {
        codeValue = "9006";
      }
      this.pageNo = this.pageNo === 1 ? 1 : this.pageNo - 1;
      this.init(codeValue, this.pageNo, "addressChange");
    },
    moreRightData(item) {
      console.log(this.activeName1, "moreData");
      let codeValue = "";
      if (this.activeName1 == "tab0") {
        codeValue = "9001";
      }
      if (this.activeName1 == "tab1") {
        codeValue = "9002";
      }
      if (this.activeName1 == "tab2") {
        codeValue = "9003";
      }
      if (this.activeName1 == "tab3") {
        codeValue = "9004";
      }
      if (this.activeName1 == "tab4") {
        codeValue = "9005";
      }
      if (this.activeName1 == "tab5") {
        codeValue = "9006";
      }
      this.init(codeValue, this.pageNo + 1, "addressChange");
    },
    addressChange() {
      let codeValue = "";
      if (this.activeName1 == "tab0") {
        codeValue = "9001";
      }
      if (this.activeName1 == "tab1") {
        codeValue = "9002";
      }
      if (this.activeName1 == "tab2") {
        codeValue = "9003";
      }
      if (this.activeName1 == "tab3") {
        codeValue = "9004";
      }
      if (this.activeName1 == "tab4") {
        codeValue = "9005";
      }
      if (this.activeName1 == "tab5") {
        codeValue = "9006";
      }
      this.init(codeValue, this.pageNo, "addressChange");
    },
    handleClickOne(tab) {
      console.log(tab, "tab");
      let codeValue = "";
      if (tab.index == "0") {
        codeValue = "9001";
      }
      if (tab.index == "1") {
        codeValue = "9002";
      }
      if (tab.index == "2") {
        codeValue = "9003";
      }
      if (tab.index == "3") {
        codeValue = "9004";
      }
      if (tab.index == "4") {
        codeValue = "9005";
      }
      if (tab.index == "5") {
        codeValue = "9006";
      }
      this.init(codeValue, 1, "addressChange");
    },
    setItemRef(el) {
      if (el) {
        this.itemRefs[el.id] = el;
      }
    },
    showDialog(item, index, index1, event) {
      this.hoverIndex = index1;
      this.$nextTick(() => {
        // console.log(
        //   document.getElementById('echartsContainer' + `${index}${index1}`),
        //   "echartsContainer"
        // );

        if (document.getElementById("echartsContainer" + `${index}${index1}`)) {
          qryMySteelTrendInfo({ indexCode: item.indexCode }).then(res => {
            if (res.data.code === "0") {
              var myChart = echarts.init(
                document.getElementById(
                  "echartsContainer" + `${index}${index1}`
                )
              );
              console.log(res.data.data.openValueList, "myChart");
              myChart.setOption({
                title: {
                  text: ""
                },
                tooltip: {
                  trigger: "axis"
                },
                legend: {
                  data: ["开盘价格", "收盘价格"]
                },
                grid: {
                  left: "1%",
                  right: "5%",
                  bottom: "3%",
                  show: false,
                  containLabel: true
                },
                // toolbox: {
                //   feature: {
                //     saveAsImage: {}
                //   }
                // },
                xAxis: {
                  type: "category",
                  axisTick: {
                    show: false // 确保刻度线显示
                  },
                  boundaryGap: false,
                  data: res.data.data.dateList,
                  splitLine: {
                    show: true, // 是否显示分割线，默认数值轴显示，类目轴不显示
                    lineStyle: {
                      color: "#D3F2F5", // 分割线颜色
                      type: "solid" // 分割线类型
                    }
                  },
                  axisLabel: {
                    show: true,
                    interval: 0,
                    formatter: val => val.slice(5),
                    textStyle: {
                      color: "#4A4A4A",
                      fontSize: 8,
                      fontSize: "13px"
                    }
                  },
                  axisLine: {
                    show: true, // 控制Y轴线是否显示
                    lineStyle: {
                      color: "rgba(0, 137, 239)" // Y轴线颜色
                    }
                  }
                },
                yAxis: {
                  type: "value",
                  boundaryGap: false,
                  // interval: 30,
                  axisTick: {
                    show: false // 确保刻度线显示
                  },
                  interval: 50,
                  min: Math.floor(res.data.data.minDataValue / 50) * 50,
                  max: Math.ceil(res.data.data.maxDataValue / 50) * 50,
                  name: res.data.data.cpName,
                  splitLine: {
                    show: true, // 是否显示分割线，默认数值轴显示，类目轴不显示
                    lineStyle: {
                      color: "#D3F2F5", // 分割线颜色
                      type: "solid" // 分割线类型
                    }
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: "#4A4A4A",
                      fontSize: 8,
                      fontSize: "13px"
                    }
                  },
                  axisLine: {
                    show: true, // 控制Y轴线是否显示

                    lineStyle: {
                      color: "rgba(0, 137, 239)", // Y轴线颜色
                      width: 2, // Y轴线宽度
                      type: "solid" // Y轴线类型
                    }
                  }
                },
                series: [
                  {
                    name: "开盘价格",
                    type: "line",
                    // stack: "Total",
                    showSymbol: false,
                    lineStyle: {
                      width: 3 // 设置线条宽度
                    },
                    color: "#3ca6fa",
                    data: res.data.data.openValueList,
                    smooth: true
                  },
                  {
                    name: "收盘价格",
                    type: "line",
                    // stack: "Total",
                    showSymbol: false,
                    lineStyle: {
                      width: 3 // 设置线条宽度
                    },
                    color: "#fdca8b",
                    data: res.data.data.closeValueList,
                    smooth: true
                  }
                ]
              });
            }
          });
        }
      });
    },
    hideDialog(item, index, index1) {
      console.log(index, index1, "hideDialog");
      this.hoverIndex = null;
      // // this.$set(this, "showChart", false);
      var element = document.getElementById(
        "echartsContainer" + `${index}${index1}`
      );
      element.remove();
    }
  }
};
</script>

<style scoped lang="scss">
.dataNull {
  text-align: center;
  color: #909399;
  font-size: 13px;
  margin-top: 60px;
}
/deep/ .el-tabs__content {
  overflow: visible !important;
}
.dialog {
  // display: none;
  position: relative;
  width: 381px;
  height: 300px;
  background-color: #fff;
  box-shadow: 5px 5px 13px 1px rgba(0, 0, 0, 0.3);
  padding: 10px;
  z-index: 10;
  text-align: left;
  right: 50%;
  .areaName {
    position: absolute;
    top: 50px;
    right: 23px;
  }
  .cpName {
    position: absolute;
    top: 50px;
    left: 23px;
  }
  .triangle-down {
    position: absolute;
    top: -9px;
    right: 50%;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 9px solid #fff;
  }
  .ZXtitle {
    font-weight: 600;
    font-size: 14px;
    color: #4a4a4a;
    line-height: 20px;
    text-align: center;
  }
}

li:hover .dialog {
  display: block;
}
.price-guidance-tabs {
  position: relative;

  .left-btn {
    position: absolute;
    top: 37%;
    left: -20px;
    width: 18px;
    height: 40px;
    line-height: 45px;
    text-align: center;
    background: #9c9c9c;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    .el-icon-caret-left {
      color: #ebebeb;
      font-size: 18px;
    }
    &:hover {
      cursor: pointer;
      background: #0089ef;
    }
  }
  .right-btn {
    position: absolute;
    top: 37%;
    right: 0px;
    width: 18px;
    height: 40px;
    line-height: 45px;
    background: #9c9c9c;
    text-align: center;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    .el-icon-caret-right {
      color: #ebebeb;
      font-size: 18px;
    }
    &:hover {
      cursor: pointer;
      background: #0089ef;
    }
  }
}
.price-guidance {
  position: relative;
  width: 1160px;
  height: 269px;
  margin-top: 20px;
  background: #ffffff;
  padding: 12px 0px 11px 20px;
  .title {
    font-weight: 600;
    font-size: 20px;
    color: #4a4a4a;
    line-height: 28px;
    text-align: left;
    margin-right: 20px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    .focusNew {
      width: 242px;
      height: 86px;
      background: #f3f7ff;
      margin: 0 20px 12px 0;
      padding: 7px 14px;
      border-radius: 6px;
      .top {
        font-weight: 600;
        font-size: 13px;
        color: #4a4a4a;
        line-height: 18px;
        text-align: left;
      }
      .content {
        display: flex;
        justify-content: space-between;
        font-weight: 400;
        font-size: 13px;
        color: #999999;
        line-height: 18px;
        text-align: left;
        margin-top: 10px;
        .openPrice {
          display: flex;
          line-height: 34px;
          .price {
            position: relative;
            font-weight: 600;
            font-size: 24px;
            color: #ff4747;
            line-height: 33px;
            text-align: left;
            margin-left: 5px;
            .el-icon-top {
              position: absolute;
              right: -22px;
              top: 6px;
              font-weight: 800;
              font-size: 22px;
            }
            .el-icon-bottom {
              position: absolute;
              right: -22px;
              top: 6px;
              font-weight: 800;
              font-size: 22px;
            }
            .el-icon-plus {
              position: absolute;
              font-size: 7px;
              font-weight: 1000;
            }
          }
        }
        .closePrice {
          display: flex;
          line-height: 34px;
          .price {
            position: relative;
            font-weight: 600;
            font-size: 13px;
            color: #2ba571;
            line-height: 33px;
            text-align: left;
            margin-left: 5px;
          }
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 7px;
        .address {
          font-weight: 400;
          font-size: 12px;
          color: #4a4a4a;
          line-height: 17px;
          text-align: left;
        }
        .time {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
          text-align: left;
        }
      }
    }
  }
  .location-select {
    position: absolute;
    top: 18px;
    right: 26%;
    font-weight: 500;
    font-size: 13px;
    color: #4a4a4a;
    line-height: 18px;
    /deep/ .el-select {
      width: 46px !important;
    }
    /deep/ .el-input--suffix .el-input__inner {
      padding: 0 !important;
      border: none !important;
    }
  }
  /deep/ .el-tabs__header {
    margin-bottom: 16px;
  }
  .notice-more {
    position: absolute;
    top: 17px;
    right: 20px;
    line-height: 30px;
    &:hover {
      color: #0089ef;
    }
  }
}
/deep/.el-tabs__nav-wrap {
  padding-top: 3px;
  padding-right: 60px;
  left: 10%;
}
/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-prev {
  line-height: 24px;
}

/deep/ .el-tabs__nav-next {
  line-height: 24px;
  right: 40px;
}
/deep/ .el-tabs__item {
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
  text-align: center;
  margin-right: 10px;
  min-width: 88px;
  height: 36px;
  line-height: 36px;
  border-radius: 16px;
  box-sizing: border-box;
}
/deep/ .is-active {
  color: #ffffff;
}

/deep/ .el-tabs__item:hover {
  color: #0089ef;
  background: rgba(0, 137, 239, 0.06);
  border: 1px solid #0089ef;
  border-radius: 16px;
}
/deep/ .el-tabs__item.is-active {
  color: #ffffff;
  background: #0089ef;
  border-radius: 16px;
  border: none;
  border: 1px solid #0089ef;
}
</style>
